import React from 'react';
import { useAuth } from '../context/AuthContext';
import './OutofHoursPage.css';

const OutofHoursPage = ({ horaActual, config }) => {
  const { logout } = useAuth();
  const timeString = horaActual ? horaActual.toLocaleTimeString() : new Date().toLocaleTimeString();
  
  // Formatear horas para mostrar (ej. 06:00 -> 06:00 AM)
  const formatTime = (timeStr) => {
    if (!timeStr) return '';
    const [hours, minutes] = timeStr.split(':');
    let h = parseInt(hours, 10);
    const ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12;
    h = h ? h : 12;
    return `${h.toString().padStart(2, '0')}:${minutes} ${ampm}`;
  };

  const horaInicio = config?.hora_inicio_sesion ? formatTime(config.hora_inicio_sesion) : '06:00 AM';
  const horaCierre = config?.hora_cierre_sesion ? formatTime(config.hora_cierre_sesion) : '10:00 PM';

  return (
    <div className="out-of-hours-container">
      <div className="out-of-hours-card">
        <div className="out-of-hours-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
        </div>
        <h1 className="out-of-hours-title">Sistema Cerrado</h1>
        <p className="out-of-hours-message">
          El sistema de requerimientos se encuentra cerrado por políticas de seguridad nocturna. 
          No se permite el acceso al sistema fuera de las horas operativas.
        </p>
        
        <div className="out-of-hours-schedule">
          <p>⏰ Horario de Operación: <strong>{horaInicio} - {horaCierre}</strong></p>
          <p>⌚ Hora actual del sistema: <strong>{timeString}</strong></p>
        </div>

        <div className="out-of-hours-actions">
          <button className="btn-primary" onClick={logout}>
            Cerrar Sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default OutofHoursPage;
